export default theme => ({
  container: {
    display: 'flex',
    alignItems: 'baseline',
  },
  h2: {
    fontSize: '2rem',
    color: theme.palette.common.white,
    margin: theme.spacing(3),
    textTransform: 'capitalize',
  },
  button: {},
  arrow: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    width: '50px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10,
    transition: 'all 0.2s',
    '&.prevArrow': { left: '10px' },
    '&.nextArrow': { right: '10px' },
  },
  arrowIcon: {
    background: 'rgba(255,255,255,0.9)',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
    transition: 'all 0.2s',
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      padding: '5px',
    },
  },
  slider: {
    '& .slick-list': {
      borderRadius: '0px',
      overflow: 'hidden',
    },
    '& .slick-slide': {
      padding: '0',
    },
    '& .slick-dots': {
      bottom: '-36px',
      display: 'flex !important',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '6px',
      padding: '0',
      listStyle: 'none',
    },
    '& .slick-dots li': {
      width: '8px',
      height: '8px',
      margin: '0 3px',
      transition: 'all 0.3s',
    },
    '& .slick-dots li button': {
      width: '8px',
      height: '8px',
      padding: '0',
    },
    '& .slick-dots li button:before': {
      content: '""',
      display: 'block',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      background: '#ccc',
      opacity: 1,
      fontSize: '0',
      transition: 'all 0.3s',
    },
    '& .slick-dots li.slick-active': {
      width: '28px',
    },
    '& .slick-dots li.slick-active button': {
      width: '28px',
    },
    '& .slick-dots li.slick-active button:before': {
      width: '28px',
      height: '8px',
      borderRadius: '4px',
      background: '#cc0000',
      opacity: 1,
    },
  },
});